/* Copyright Flexday Solutions LLC, Inc - All Rights Reserved

 * Unauthorized copying of this file, via any medium is strictly prohibited

 * Proprietary and confidential

 * See file LICENSE.txt for full license details.

 */

export const getAll = (builder) =>
  builder.query({
    query: () => ({
      url: `language-models`,
      method: 'GET',
    }),
    providesTags: ['language-models'],
  });

export const get = (builder) =>
  builder.query({
    query: ({ id }) => {
      return {
        url: `language-models/${id}`,
        method: 'GET',
      };
    },
    invalidatesTags: ['language-model'],
  });

export const create = (builder) =>
  builder.mutation({
    query: ({ body }) => {
      return {
        url: `language-models`,
        method: 'POST',
        body: body,
      };
    },
    invalidatesTags: ['language-models'],
  });

export const update = (builder) =>
  builder.mutation({
    query: ({ update, id }) => {
      return {
        url: `language-models/${id}`,
        method: 'PATCH',
        body: update,
      };
    },
    invalidatesTags: ['language-models'],
  });

export const deleteMany = (builder) =>
  builder.mutation({
    query: ({ ids }) => {
      return {
        url: `language-models`,
        method: 'DELETE',
        body: { ids },
      };
    },
    invalidatesTags: ['language-models'],
  });
